import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { JobListFacets } from '@nest-recruit/shared';
import { ApiError, request } from '../../../lib/api-client';
import { JOBS_KEY, type JobListParams } from './jobs-api';

// Redesign Group 2: JOB-01's View menu counts. Under `['jobs']`, so the server's realtime hint for
// jobs and every job mutation's invalidation recount them (non-negotiable #12).

/** The list's filters without its page: what the counts are taken over. */
export type JobListFacetParams = Omit<JobListParams, 'page' | 'pageSize'>;

export function useJobListFacets(params: JobListFacetParams): UseQueryResult<JobListFacets, ApiError> {
  return useQuery<JobListFacets, ApiError>({
    queryKey: [...JOBS_KEY, 'facets', params],
    queryFn: ({ signal }) => request<JobListFacets>('/jobs/facets', { query: { ...params }, signal }).then((result) => result.data),
    // The counts beside a ticked option stay while the next ones load (CLAUDE.md §5a rule 2).
    placeholderData: (previous) => previous,
  });
}
